module.exports = __webpack_public_path__ + "img/featureCosme.007.0a709724.jpeg";